import { MotifProgressLoader } from "@ey-xd/motif-react";
import "./LoadingIndicator.scss";

// Displays loading spinner overlay with optional fullscreen mode
export function LoadingIndicator({
  show,
  fullscreen = true,
  children,
  transparent = false,
  className = "",
}) {
  return (
    <>
      {show ? (
        <MotifProgressLoader
          show={true}
          fullscreen={fullscreen}
          className={`app-loading-indicator ${className} ${
            transparent ? "app-loading-indicator-transparent" : ""
          }`}
        ></MotifProgressLoader>
      ) : (
        children
      )}
    </>
  );
}
